import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "./lib/auth";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Jobs from "./pages/Jobs";
import JobDetail from "./pages/JobDetail";
import Employers from "./pages/Employers";
import EmployerDetail from "./pages/EmployerDetail";
import Industries from "./pages/Industries";
import AIMatch from "./pages/AIMatch";
import Dashboard from "./pages/Dashboard";
import AuthCallback from "./pages/AuthCallback";
import Compare from "./pages/Compare";
import PostJob from "./pages/PostJob";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import EmployerDashboard from "./pages/EmployerDashboard";
import StateSponsor from "./pages/StateSponsor";
import Profile from "./pages/Profile";
import PublicProfile from "./pages/PublicProfile";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Nav />
      <main className="min-h-[70vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:id" element={<JobDetail />} />
          <Route path="/employers" element={<Employers />} />
          <Route path="/employers/:id" element={<EmployerDetail />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/ai-match" element={<AIMatch />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/post-job" element={<PostJob />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/employer-dashboard" element={<EmployerDashboard />} />
          <Route path="/sponsor-state" element={<StateSponsor />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/u/:userId" element={<PublicProfile />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App noise-bg min-h-screen bg-black text-white">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
